import React from 'react';
import { HelpCircle, MessageCircleQuestion } from 'lucide-react';

const ConsultationCTA = ({ 
  title = "Unsure About the Right Choice?", 
  description = "Get a Free Personalized Consultation",
  buttonText = "Free Consultation",
  message
}) => {
  const onConsultClick = () => {
    const phoneNumber =  process.env.REACT_APP_WHATSAPP_NO;
    const formattedNumber = phoneNumber.replace(/\D/g, '');
    const whatsappUrl = `https://wa.me/${formattedNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className="bg-gradient-to-r from-pink-50 to-pink-100 rounded-xl p-4 sm:p-6 md:p-8 shadow-md flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 my-6 sm:my-8">
      <div className="flex items-start sm:items-center gap-3 sm:gap-4 w-full sm:w-auto">
        <div className="hidden sm:block">
          <MessageCircleQuestion 
            className="text-pink-600" 
            size={36}
            strokeWidth={1.5} 
          />
        </div>
        <div className="flex-1 sm:flex-initial">
          <h3 className="text-base sm:text-lg md:text-xl font-semibold text-gray-800 mb-1 sm:mb-2">
            {title}
          </h3>
          <p className="text-gray-600 text-xs sm:text-sm md:text-base">
            {description}
          </p>
        </div>
      </div>
      <button 
        onClick={onConsultClick}
        variant="primary"
        className="w-full sm:w-auto bg-pink-600 text-white px-3 sm:px-4 py-2 rounded-lg hover:bg-pink-700 transition-colors flex items-center justify-center sm:justify-start gap-2 text-sm sm:text-base"
      >
        <HelpCircle size={18} className="sm:w-5 sm:h-5" />
        {buttonText}
      </button>
    </div>
  );
};

export default ConsultationCTA;